export const PRODUCT_VARIANT_URL_SEPERATOR = "." as const;
